import { useQuery } from "@tanstack/react-query"
import { customerLogsQuery } from "../lib/customerLogsQuery"

export function useCustomerLogsQuery(customerId: string) {
  return useQuery(customerLogsQuery(customerId))
}
